import React from 'react';
import styled from 'styled-components';
import MaskedInput from 'react-text-mask';
import { TextControlProps } from '../models';
import { inputStyle } from '../styles';

const s = {
  Input: styled.input`
    ${inputStyle};
    display: block;
    width: 100%;
  `,
};

const TextControl: React.FC<TextControlProps> = (props) => {
  return props.maskOptions ? (
    <MaskedInput
      {...props}
      {...props.maskOptions}
      render={(ref, inputProps) => <s.Input ref={ref} {...inputProps} />}
    />
  ) : (
    <s.Input {...props} />
  );
};

export default TextControl;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/controls/TextControl.tsx